import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { modeBannerTitle } from "../lockbox/utils/appLibrarySuggestions.js";
import { pickerCategoryLabel, behavioralToPickerId } from "../lockbox/utils/categoryPickerCatalog.js";

/**
 * View C — mode-aware distracting-app suggestions (not auto-blocks).
 *
 * @param {{
 *   modeId: string,
 *   apps: import('../lockbox/domain/types.js').LockboxAppEntity[],
 *   onBlockAll: () => void,
 *   onReviewEach: () => void,
 *   onDismiss?: () => void,
 * }} props
 */
export function ModeDistractingBanner({ modeId, apps, onBlockAll, onReviewEach, onDismiss }) {
  if (!apps.length) return null;

  return (
    <View style={styles.card}>
      <Text style={styles.title}>{modeBannerTitle(modeId)}</Text>
      <Text style={styles.sub}>We think these apps may be distracting:</Text>
      {apps.map((app) => {
        const cat = app.classification?.primaryCategory || "unknown";
        const pickerId = behavioralToPickerId(cat);
        return (
          <Text key={app.id} style={styles.bullet}>
            • {app.displayName} ({pickerCategoryLabel(pickerId)})
          </Text>
        );
      })}
      <View style={styles.actions}>
        <Pressable style={styles.blockAllBtn} onPress={onBlockAll}>
          <Text style={styles.blockAllText}>Block All</Text>
        </Pressable>
        <Pressable style={styles.reviewBtn} onPress={onReviewEach}>
          <Text style={styles.reviewText}>Review Each</Text>
        </Pressable>
      </View>
      {onDismiss ? (
        <Pressable onPress={onDismiss} style={styles.dismissWrap}>
          <Text style={styles.dismiss}>Not now</Text>
        </Pressable>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#eff6ff",
    borderRadius: 12,
    padding: 14,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#bfdbfe",
  },
  title: { fontSize: 15, fontWeight: "800", color: "#1e3a8a", marginBottom: 6 },
  sub: { fontSize: 13, color: "#1e40af", marginBottom: 8 },
  bullet: { fontSize: 13, color: "#1e3a8a", marginLeft: 4, marginBottom: 4 },
  actions: { flexDirection: "row", gap: 10, marginTop: 12 },
  blockAllBtn: {
    flex: 1,
    backgroundColor: "#dc2626",
    paddingVertical: 10,
    borderRadius: 8,
    alignItems: "center",
  },
  blockAllText: { color: "#fff", fontWeight: "800", fontSize: 13 },
  reviewBtn: {
    flex: 1,
    backgroundColor: "#fff",
    paddingVertical: 10,
    borderRadius: 8,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#2563eb",
  },
  reviewText: { color: "#2563eb", fontWeight: "800", fontSize: 13 },
  dismissWrap: { marginTop: 10, alignItems: "center" },
  dismiss: { color: "#64748b", fontWeight: "600", fontSize: 12 },
});
